import { ASMainGamePickOptions, WINTYPE } from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ASWinData,
    ActionSpinOptions,
    ActionSpinSound,
    PromoPanelGameConfiguration,
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import { Helper } from "@nolimitcity/promo-panel/bin/utils/Helper";

import { EventsManager, ReelsEvents } from "../../abstracts/events/EventsManager";
import { AbstractGameMode } from "../../abstracts/flow/AbstractGameMode";
import { BackgroundNames, WinType } from "../../abstracts/types/enums";
import { playSound } from "../../abstracts/utils/SoundUtils";
import { DDD } from "../DDD";
import { DDDSoundNames } from "../assetsLoader/DDDAssetsNames";
import { DDDGameData } from "../types/DDDInterfaces";
import { boostedName, getWinLevel, xbet2Name, xbetName } from "./DDDConfig";

export class DDDPromoPanelConfig implements PromoPanelGameConfiguration {
    constructor() {}

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: `DDDDeadOrDeadOrDead`,
            hasActionSpin: true,
            graphics: { backgroundTextureName: BackgroundNames.NORMAL },
            mainGame: {
                header: () => `xBET`,
                options: [
                    { name: `NORMAL`, id: 0, image: `NORMAL.png` },
                    { name: boostedName, id: 1, image: `BOOSTED_BET.png` },
                ],
                type: ASMainGamePickOptions.BOOSTED_BET,
            },
            getParsedData: (response: DDDGameData): ASWinData => {
                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
                    totalSpinWinnings: response.win,
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: response.brokeTheBank,
                };
                return parsedData;
            },
        };
    }

    private isBigWin(response: DDDGameData): boolean {
        let win = response.win;
        if (
            response.mode === AbstractGameMode.RESPIN &&
            response.nextMode !== AbstractGameMode.RESPIN
        ) {
            win = response.accumulatedRoundWin;
        }

        if (response.wasFeatureBuy || response.boostedBet) {
            let betPrice = DDD.model.getBetPrice(); //TODO needs AS fix
            let winRatio: number = Math.round((win / betPrice) * 10000) / 10000;
            let winLevel = getWinLevel(winRatio);

            if (
                response.boostedBet &&
                (DDD.model.buyFeatureName === xbetName || DDD.model.buyFeatureName === xbet2Name)
            ) {
                betPrice = DDD.model.gameData?.playedBetValue;

                winRatio = Math.round((win / betPrice) * 10000) / 10000;

                winLevel = getWinLevel(winRatio);

                return (
                    winRatio >= 1 &&
                    (winLevel.winType === WinType.BIG || winLevel.winType === WinType.MAX_CAP)
                );
            }

            // console.log(`winLevel`, winLevel);

            return winRatio >= 1;
        }

        let winRatio: number = Helper.ceilToDecimals(win / response.playedBetValue, 2);

        const winLevel = getWinLevel(winRatio);

        return winLevel.winType === WinType.BIG || winLevel.winType === WinType.MAX_CAP;
    }

    private isFreeSpinTriggered(response: DDDGameData): boolean {
        if (response.nextMode !== response.mode) {
            EventsManager.trigger(ReelsEvents.REMOVE_FAKE_SCATTERS);
        }

        return (
            response.mode === AbstractGameMode.NORMAL &&
            (response.nextMode === AbstractGameMode.FREESPIN ||
                response.nextMode === AbstractGameMode.SUPER_FREESPIN)
        );
    }

    private getFeatureName(response: DDDGameData): string {
        if (
            response.mode == AbstractGameMode.FREESPIN ||
            response.nextMode == AbstractGameMode.FREESPIN
        ) {
            return `DEAD SPINS`;
        } else if (
            response.mode == AbstractGameMode.SUPER_FREESPIN ||
            response.nextMode == AbstractGameMode.SUPER_FREESPIN
        ) {
            return `DEADER SPINS`;
        }

        return response.mode;
    }

    private isRoundComplete(response: DDDGameData): boolean {
        const isComplete =
            [
                AbstractGameMode.FREESPIN,
                AbstractGameMode.SUPER_FREESPIN,
                AbstractGameMode.NORMAL,
                // AbstractGameMode.RESPIN,
            ].indexOf(response.nextMode) > -1;

        return isComplete;
    }

    private isBonusEnd(response: DDDGameData): boolean {
        return (
            response.nextMode === AbstractGameMode.NORMAL &&
            (response.mode === AbstractGameMode.FREESPIN ||
                response.mode === AbstractGameMode.SUPER_FREESPIN)
        );
    }

    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger == ActionSpinSound.WIN) {
            playSound({ name: DDDSoundNames.AS_WIN });
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            playSound({ name: DDDSoundNames.AS_WIN_BIG });
        }
    }
}
